import { render, staticRenderFns } from "./RevisarReserva.vue?vue&type=template&id=33b8a96c&scoped=true&"
import script from "./RevisarReserva.vue?vue&type=script&lang=ts&"
export * from "./RevisarReserva.vue?vue&type=script&lang=ts&"
import style0 from "./RevisarReserva.vue?vue&type=style&index=0&id=33b8a96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b8a96c",
  null
  
)

export default component.exports